<script setup lang="ts">
const { time } = useServerTiming();

const { data: podcasts } = await time("GetPodcastCards", () =>
  useAsyncGql(
    "GetPodcastCards",
    {
      language: "no-nb",
      version: useCrystallizeVersion(),
    },
    {
      transform(data) {
        return data.catalogue?.subtree.edges?.map((it) =>
          toPodcastCard(it.node),
        );
      },
    },
  ));
</script>

<template>
  <section class="flex flex-col items-center justify-end gap-8 bg-coral-20 pb-14 pt-8 md:gap-18 md:pb-20 md:pt-16 lg:pb-28 lg:pt-20">
    <div class="flex flex-col items-center gap-4 md:gap-8">
      <UiGraphicsWave class="stroke-red-50" />
      <h1 class="text-center text-xl font-semibold uppercase tracking-widest text-red-50">
        Våre Podkaster
      </h1>
    </div>
    <UiStripesPodcasts
      v-if="podcasts?.length"
      :podcasts="podcasts"
    />
  </section>
</template>
